export { QuickLinks } from './QuickLinks';
export { useOnNavigateToSectionClick } from './QuickLinks.hooks';
